module.exports = __webpack_public_path__ + "img/culture_03.b440001c.png";